import { profileActions } from "../slices/profileSlice";

import { toast } from "react-toastify";
import { authActions } from "../slices/authSlice";
import axios from "axios";


//Get user profile
export function getUserProfile(userId) {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/users/profile/${userId}`
      );
      dispatch(profileActions.setProfile(data));
    } catch (error) {
      toast.error(error.response);
    }
  };
}
// //Upload profile photo
// export function uploadProfilePhoto(newPhoto) {
//   return async (dispatch, getState) => {
//     try {
//       const { data } = await request.post(
//         `/api/users/profile/profile-photo-upload`,
//         newPhoto,
//         {
//           headers: {
//             Authorization: "Bearer " + getState().auth.user.token,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       dispatch(profileActions.setProfilePhoto(data?.profilePhoto));
//       dispatch(authActions.setUserPhoto(data?.profilePhoto));
//       toast.success(data?.message);
//       //Modify the user in local storage with new photo
//       const user = JSON.parse(localStorage.getItem("userInfo"));
//       user.profilePhoto = data?.profilePhoto;
//       localStorage.setItem("userInfo", JSON.stringify(user));
//     } catch (error) {
//       toast.error(error.response.data.message);
//     }
//   };
// }
//Update profile
export function updateProfile(userId, profile) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.put(
        `https://tabeeb-assyut-api.onrender.com/api/users/profile/${userId}`,
        profile,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(profileActions.updateProfile(data));
      dispatch(authActions.setUsername(data?.username));

      //Modify the user in local storage with new photo
      const user = JSON.parse(localStorage.getItem("userInfo"));
      user.username = data?.username;
      localStorage.setItem("userInfo", JSON.stringify(user));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Delete profile (Account)
export function deleteProfile(userId) {
  return async (dispatch, getState) => {
    try {
      dispatch(profileActions.setLoading());
      const { data } = await axios.delete(
        `https://tabeeb-assyut-api.onrender.com/api/users/profile/${userId}`,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(profileActions.setIsProfileDeleted());
      toast.success(data?.message);
      setTimeout(() => dispatch(profileActions.clearIsProfileDeleted()), 2000);
    } catch (error) {
      toast.error(error.response.data.message);
      dispatch(profileActions.clearLoading());
    }
  };
}
//Get all users profile (For admin dashboard)
export function getUsersProfile() {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/users/profile`,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(profileActions.setProfiles(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//get profiles count (For admin dashboard)
export function getUsersCount() {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/users/count`,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(profileActions.setUserCount(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
